export interface PurchaseOption {
  id: string;
  icon: string;
  label: string;
  subLabel: string;
  url: string;
  colorClass: string;
}

export interface Product {
  id: string;
  title: string;
  description: string;
  price: string;
  image: string;
  category: string;
  badge?: string;
  purchaseOptions: PurchaseOption[];
}

export const categories = [
];

export const products: Product[] = [
];

export const testimonials = [
];
